export default Object.freeze({
  LIVESTREAM: 'livestream',
  TOKBOX: 'tokbox'
})
